<label
  class="image-option-label"
  [ngClass]="{
    'selected': isSelected,
    'disabled': isDisabled && !isSelected,
    'appear-disabled': appearDisabled && !isSelected
  }">
  <button
    class="image-button"
    [attr.aria-label]="option?.text"
    name="{{ option?.text }}"
    [disabled]="isDisabled && !isSelected"
    (click)="onImageSelect(option)">
    <img class="image-option" [src]="imageIconSrc" alt="{{ option?.text }}" />
    <svg-icon
      class="icon-selected"
      *ngIf="questionType === questionTypes.image_tile && isSelected"
      src="/assets/icons/checkmark-filled-circle.svg"></svg-icon>
  </button>
  <!-- explicitly removing this label from aria as the words are read via aria-label on the button -->
  <span class="image-label" *ngIf="showTextUnderImage" aria-hidden="true">{{ option?.text }}</span>
</label>
